import * as types from './quartals.types';
import * as constants from './quartals.constants';

export const initialQuartalsPage = (): types.IInitialQuartalsPage => ({
  type: constants.INITIAL_QUARTALS_PAGE,
});
